import { DefaultFormMultiSelectField } from "../../../../../common/components/forms/inputs/dropdown/DefaultFormMultiSelectField";
import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";
import { RenderWhen } from "../../../../../common/infrastructure/components/RenderWhen";
import { IClassWizardFormModel } from "../models/classWizardFormModel";
import styles from "../ClassWizard.module.scss";
import { nameof } from "ts-simple-nameof";
import { DefaultToggle } from "../../../../../common/components/forms/inputs/toggle/DefaultToggle";

interface IEventWizardRecurringVisitorsInputProps {
  isIndividualEvent: boolean;
  hasRecurringVisitors?: boolean | null;
  allUsers?: ISelectFieldModel[];
}

export const EventWizardRecurringVisitorsInput = ({
  isIndividualEvent,
  hasRecurringVisitors,
  allUsers,
}: IEventWizardRecurringVisitorsInputProps) => {
  return (
    <RenderWhen condition={!isIndividualEvent}>
      <DefaultToggle
        name={nameof<IClassWizardFormModel>((x) => x.hasRecurringVisitors)}
        className={styles.root_recurring_checkbox}
        label="Този клас има повтарящи се посетители"
      />
      <RenderWhen condition={!!hasRecurringVisitors}>
        <DefaultFormMultiSelectField
          label="Кои посетители ще се повтарят всеки път, когато има такъв клас?"
          name={nameof<IClassWizardFormModel>((x) => x.recurringVisitorsIds)}
          options={allUsers}
          required
          filter
          // Every client of the studio: render only the rows in view, like the sign-up page.
          virtualScrollerOptions={{ itemSize: 43 }}
        />
      </RenderWhen>
    </RenderWhen>
  );
};
